/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "FullPaymentReportService";
const log: any = LoggerModule.getInstance();

export class FullPaymentReportService {
  private static instance: FullPaymentReportService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }
  public static getInstance(props: any = {}): FullPaymentReportService {
    if (!FullPaymentReportService.instance) {
      FullPaymentReportService.instance = new FullPaymentReportService(props);
    }
    return FullPaymentReportService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
  public async getFullPaymentUsers(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    if (args) {
      this.setCriteria(args);
    }
    compProps = await agent?.getFullPaymentUsers(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
}
